exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nselect.form-control[data-v-65747a03] {\n    height:34px!important;\n}\nselect.to-check[data-v-65747a03] {\n    border:1px solid rgba(206, 0, 91, 0.66)\n}\n.green[data-v-65747a03] {\n    color: green;\n}\n.red[data-v-65747a03] {\n    color: red;\n}\n", ""]);

// exports
